import { ESearchFilters } from '@/constants/searchFilters';

// Filters that should be preserved when switching modes (Location, Dates, Guests)
const PRESERVED_FILTERS = new Set([
  ESearchFilters.ADDRESS,
  ESearchFilters.DATE_FROM,
  ESearchFilters.DATE_TO,
  ESearchFilters.FLEXIBLE_DAYS,
  ESearchFilters.GUESTS_ADULTS,
  ESearchFilters.GUESTS_CHILDREN,
  ESearchFilters.GUESTS_INFANTS,
  ESearchFilters.SEATBELTS,
  ESearchFilters.SLEEPS,
  ESearchFilters.BOUNDS_NE,
  ESearchFilters.BOUNDS_SW,
  ESearchFilters.NEAR,
  ESearchFilters.GEOIP_ADDRESS,
  ESearchFilters.MAPBOX_ID,
  ESearchFilters.FULL_MAPBOX_ADDRESS,
  ESearchFilters.LOCATION_IDS,
  ESearchFilters.RADIUS,
  ESearchFilters.AUTO_RADIUS,
  // Keep pagination and basic search params
  ESearchFilters.PAGE_LIMIT,
  ESearchFilters.PAGE_OFFSET,
]);

const TO_DELIVERY_MODE_PRESERVED_FILTERS = new Set([ESearchFilters.DELIVERY_ADDRESS]);

/**
 * Extracts only the preserved filters (Location, Dates, Guests) from the current query params and form state
 * @param currentQueryParams - The current query parameters from Redux state
 * @param isSwitchingToDeliveryMode - Whether switching to delivery mode
 * @param currentFormState - The current form state (optional, for fresh data)
 * @returns An object containing only the preserved filters
 */
export const getPreservedFilters = (
  currentQueryParams: Record<string, string | string[] | undefined>,
  isSwitchingToDeliveryMode = false,
  currentFormState?: Record<string, any>,
): Record<string, string | string[] | undefined> => {
  const preservedParams: Record<string, string | string[] | undefined> = {};

  Object.keys(currentQueryParams).forEach(key => {
    if (PRESERVED_FILTERS.has(key as ESearchFilters)) {
      preservedParams[key] = currentQueryParams[key];
    }
  });

  if (isSwitchingToDeliveryMode) {
    Object.keys(currentQueryParams).forEach(key => {
      if (TO_DELIVERY_MODE_PRESERVED_FILTERS.has(key as ESearchFilters)) {
        preservedParams[key] = currentQueryParams[key];
      }
    });
  }

  const queryAddress = currentQueryParams[ESearchFilters.ADDRESS];
  const queryDeliveryAddress = currentQueryParams[ESearchFilters.DELIVERY_ADDRESS];
  const formAddress = currentFormState?.[ESearchFilters.ADDRESS];
  const formDeliveryAddress = currentFormState?.[ESearchFilters.DELIVERY_ADDRESS];

  const currentAddress = queryAddress || formAddress;
  const currentDeliveryAddress = queryDeliveryAddress || formDeliveryAddress;

  if (currentDeliveryAddress) {
    preservedParams[ESearchFilters.ADDRESS] = currentDeliveryAddress;
    preservedParams[ESearchFilters.DELIVERY_ADDRESS] = currentDeliveryAddress;
  } else if (currentAddress) {
    preservedParams[ESearchFilters.ADDRESS] = currentAddress;
    preservedParams[ESearchFilters.DELIVERY_ADDRESS] = currentAddress;
  }

  return preservedParams;
};
